module.exports = __webpack_public_path__ + "static/media/maps-marker-pelayo.27c83bc3.svg";